import * as actions from 'actions/HelpCentreActions/ContactUsActions/emailUsActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
const { emailUsActionsEnum } = actions;
const defaultState = {
    asyncStatus: INIT
};
export default function emailUs(state = defaultState, action) {
    switch (action.type) {
        case emailUsActionsEnum.EMAIL_US_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case emailUsActionsEnum.EMAIL_US_SUCCESS:
            return Object.assign({}, state, action['data'], {
                asyncStatus: SUCCESS
            });
        case emailUsActionsEnum.EMAIL_US_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case emailUsActionsEnum.RESET_DATA_MODAL:
            return Object.assign({}, state, {
                asyncStatus: INIT
            });
        default:
            return state;
    }
}
